import { useState } from "react";
import PropTypes from "prop-types";
import ResultsWrappers from "../modals/ResultsWrapper";
import UserPreview from "../modals/UserPreview";

const NameLink = ({ userData, rowInfo }) => {
  // State for the review modal
  const [showUsersPreview, setShowUsersPreview] = useState(false);
  /*
  This method is passed to the modal
  and toggles the modal within this component
  */
  const toggleUserPreview = () => {
    setShowUsersPreview(!showUsersPreview);
  };

  return (
    <>
      {showUsersPreview && (
        <ResultsWrappers togglePreview={toggleUserPreview}>
          <UserPreview userInfo={userData} togglePreview={toggleUserPreview} />
        </ResultsWrappers>
      )}
      <button
        className={
          rowInfo === "topOnly"
            ? "button button--user_name_link-top"
            : "button button--user_name_link"
        }
        onClick={toggleUserPreview}
        aria-label="View User Profile"
      >
        {userData.fullname}
      </button>
    </>
  );
};

export default NameLink;

NameLink.propTypes = {
  userData: PropTypes.object,
  rowInfo: PropTypes.string,
};